// Bridge for the fixed-reconnect-cadence kill switch — Rust cannot read
// Flagsmith, so the FE pushes the value; the plugin defaults to true.
import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';
import { sanitizeError } from '@/utils/logger/sanitizeError';

export async function setFixedReconnectCadenceMacEnabled(
  enabled: boolean
): Promise<void> {
  if (!isTauri()) return;
  try {
    // eslint-disable-next-line @heidi/rules/no-new-direct-tauri-import -- no guest-js bridge for chronicle flag push yet (HAR-1847)
    const { invoke } = await import('@tauri-apps/api/core');
    await invoke<void>('chronicle_set_fixed_reconnect_cadence_mac_enabled', { enabled });
  } catch (error) {
    logger.error('[fixedReconnectCadenceMac] Failed to push flag to Rust', {
      error: sanitizeError(error),
    });
  }
}
